import { type ErrorEvent as SentryErrorEvent } from '@sentry/browser';

import { Logger } from 'src/services/Logger';
import {
	extractEventText,
	isUninformativeText,
	rebuildMessageFromArguments
} from 'src/services/SentryEventHelper';
import { IGNORE_PATTERNS } from 'src/services/SentryEventHelper.constants';

export const beforeSendDropNoise = (event: SentryErrorEvent): SentryErrorEvent | null => {
	try {
		const text = extractEventText(event);
		const patternIndex = IGNORE_PATTERNS.findIndex((pattern) => pattern.test(text));

		if (patternIndex !== -1) {
			Logger.debug('sentry-drop', { patternIndex });

			return null;
		}

		if (event.logger === 'console') {
			event.tags = { ...(event.tags ?? {}), capture_source: 'logger.error' };
		}

		const messageUninformative = isUninformativeText(event.message);
		const uninformativeExceptionValues = (event.exception?.values ?? []).filter((value) =>
			isUninformativeText(value.value)
		);

		if (messageUninformative || uninformativeExceptionValues.length > 0) {
			const rebuilt = rebuildMessageFromArguments(event);

			if (rebuilt) {
				if (messageUninformative) {
					event.message = rebuilt;
				}

				uninformativeExceptionValues.forEach((value) => {
					value.value = rebuilt;
				});
			}
		}

		return event;
	} catch {
		return event;
	}
};
